import React, { Component } from 'react';
import { FormGroup, Row, Col } from 'reactstrap';
import { Icon } from './Icon';
import CustomLoader from './CustomLoader';
import Dropzone from 'react-dropzone';
import { ToastContainer, toast } from 'react-toastify';

import upload from '../icons/upload-1.svg';

import jackdaw_white from '../icons/jackdaw_white.svg';
import cancel_white from '../icons/cancel_white.svg';

export class Actions extends Component {
	displayName = Actions.name

	constructor(props) {
		super(props);

		this.state = {
			events: [],
			loader: true,
		};
		this.addAction = this.addAction.bind(this);
		this.setActiveEvent = this.setActiveEvent.bind(this);
		this.deleteEvent = this.deleteEvent.bind(this);
		this.unsetActiveEvent = this.unsetActiveEvent.bind(this);
	}

	componentDidMount() {
		fetch('api/DataforDB/GetAllEvents')
			.then(response => {
				if (!response.ok) {
					throw Error(response.statusText);
				}
				return response.json();
			})
			.then(data => {
				this.setState({ events: data, loader: false });
			});
	}

	addAction(file) {
		var data = new FormData();

		data.append('name', file.name);
		data.append('file', file);

		const requestOptions = {
			method: 'POST',
			body: data
		};

		fetch('api/DataforDB/AddEvent', requestOptions)
			.then(response => {
				if (!response.ok) {
					throw Error(response.statusText);
				}
				return response.json();
			})
			.then(id => {
				var dataGet = new FormData();

				dataGet.append('id', id);

				const requestOptionsGet = {
					method: 'POST',
					body: dataGet
				};

				return fetch('api/DataforDB/GetEventById', requestOptionsGet)
					.then(response => {
						if (!response.ok) {
							throw Error(response.statusText);
						}
						return response.json();
					})
					.then(newAction => {
						this.setState({ events: [...this.state.events ,newAction] });
					});
			})
			.catch(error => toast.error('Произошла ошибка при загрузке акции'));
	}

	setActiveEvent(id) {
		var data = new FormData();

		data.append('eventId', id);

		const requestOptions = {
			method: 'POST',
			body: data
		};

		fetch('api/DataforDB/SetActiveEvent', requestOptions)
			.then(response => {
				if (!response.ok) {
					throw Error(response.statusText);
				}
				return response;
			})
			.then(() => {
				const newEvents = this.state.events;
				newEvents.find(x => x.id === id).isActive = 1;

				this.setState({ events: newEvents });
			});
	}

	unsetActiveEvent(id) {
		var data = new FormData();

		data.append('eventId', id);

		const requestOptions = {
			method: 'POST',
			body: data
		};

		fetch('api/DataforDB/SetNotActiveEvent', requestOptions)
			.then(response => {
				if (!response.ok) {
					throw Error(response.statusText);
				}
				return response;
			})
			.then(() => {
				const newEvents = this.state.events;
				newEvents.find(x => x.id === id).isActive = 0;

				this.setState({ events: newEvents });
			});
	}

	deleteEvent(id) {
		var data = new FormData();

		data.append('eventId', id);

		const requestOptions = {
			method: 'POST',
			body: data
		};

		fetch('api/DataforDB/RemoveEvent', requestOptions)
			.then(response => {
				if (!response.ok) {
					throw Error(response.statusText);
				}
				return response;
			})
			.then(() => {
				const newEvents = this.state.events.filter(x => x.id !== id);

				this.setState({ events: newEvents });
			});
	}

	render() {
		return (
			<React.Fragment>
				<ToastContainer/>
				<CustomLoader visible={this.state.loader} />
				<div className={this.state.loader ? 'display-none' : ''}>
					<h1>Список акций</h1>
					<Row className='products-area'>
						{this.state.events.map(e => {
							return (
								<Col xs={4} key={e.id}>
									<FormGroup className={'action-image-block' + (e.isActive ? ' active' : '')}>
										<img alt={e.name} src={e.imagePath} className='product-image'/>
										<div className='action-buttons-block'>
											{!e.isActive && <button className='action-btn' type='button' onClick={() => this.setActiveEvent(e.id)}><Icon name={jackdaw_white}/></button>}
											<button className='action-btn' type='button' onClick={() => e.isActive ? this.unsetActiveEvent(e.id) : this.deleteEvent(e.id)}><Icon name={cancel_white} /></button>
										</div>
									</FormGroup>
								</Col>
							)
						})}
						{this.state.events.length === 0 && <FormGroup className='alert alert-primary'>Не найдено акций</FormGroup>}
					</Row>
					<h2>Загрузить акцию</h2>
					<Row>
						<Col xs='auto'>
							<Dropzone onDrop={acceptedFiles => this.addAction(acceptedFiles[0])}>
								{({ getRootProps, getInputProps }) => (
									<section>
										<div className='drop-zone flex' {...getRootProps()}>
											<input type='file' {...getInputProps()} />
											<Icon className='drop-zone-icon' name={upload} />
										</div>
									</section>
								)}
							</Dropzone>
						</Col>
					</Row>
				</div>
			</React.Fragment>
		);
	}
}
